export default __webpack_public_path__ + "static/media/escuela_verde_secundaria.376049e1.jpg";